document.addEventListener('alpine:init', () => {
  Alpine.data('bottomSheet', () => ({
    dragging: false,
    prevContainerHeight: 0,
    prevDeltaY: 0,
    deltaY: 0,

    onMouseDown(event) {
      event.preventDefault();

      this.dragging = true;
      this.prevContainerHeight = this.$refs.container.offsetHeight;
      this.prevDeltaY = this.getClientY(event);
    },

    onMouseMove(event) {
      if (this.dragging) {
        this.deltaY = this.prevDeltaY - this.getClientY(event);
        this.$refs.container.style.height = this.prevContainerHeight + this.deltaY + 'px';
      }
    },

    onMouseUp() {
      if (this.deltaY <= -32) {
        setTimeout(() => {
          this.$store.bottomSheet.close();
        });
      }

      this.$refs.container.style.height = this.prevContainerHeight + 'px';
      this.dragging = false;
      this.prevContainerHeight = 0;
      this.prevDeltaY = 0;
      this.deltaY = 0;

      setTimeout(() => (this.$refs.container.style.height = null), 300);
    },

    getClientY(event) {
      if (event.touches?.length) {
        return event.touches[0].clientY;
      } else if (event.clientY !== undefined) {
        return event.clientY;
      }

      return 0;
    },
  }));
});